export default __webpack_public_path__ + "static/media/home-illustration-transparent.8392dd40.png";